<template>
  <div class="mt-4 mb-4">
    <span class="ingredient-title">{{ label }}</span>
    <datepicker v-model="date" :locale="locale" :lowerLimit="lowerLimit" inputFormat="dd.MM.yyyy" class="form-control"/>
  </div>
</template>

<script>
  import {nb} from "date-fns/locale";
  import Datepicker from '@/components/other/ToggleDatepicker.vue'
  import moment from "moment";

  export default {
    components: {Datepicker},
    props: {
      label: String,
      selectedDate: String, /* 'YYYY-MM-DD' */
      /* 'YYYY-MM-DD' — earlier dates cannot be picked at all. Used to stop a "til og med" date being set
         before the "fra og med" one, which is easier to prevent than to explain afterwards. */
      minDate: String
    },
    /* The date lived only inside this component, readable through getSelectedDate() — so a parent could
       not react to it, only ask for it when saving. Emitting keeps the parent's copy live, which is what
       lets a form validate the two dates against each other as they are picked. */
    emits: ['update:selectedDate'],
    data() {
      return {
        locale: nb,
        date: new Date()
      };
    },
    mounted() {
      if(this.selectedDate){
        //console.log(this.selectedDate);
        this.setSelectedDate(this.selectedDate);
      }
    },
    computed: {
      lowerLimit() {
        return this.minDate ? moment(this.minDate, 'YYYY-MM-DD').toDate() : undefined;
      }
    },
    watch: {
      selectedDate(newDate) {
        if(newDate) {
          this.setSelectedDate(newDate);
        }
      },
      date(newDate) {
        //Same value the parent already holds re-emits harmlessly, so this cannot loop with the watcher above.
        this.$emit('update:selectedDate', (moment(newDate)).format('YYYY-MM-DD'));
      }
    },
    methods: {
      getSelectedDate() {
        return (moment(this.date)).format('YYYY-MM-DD');
      },
      setSelectedDate(dateString) {
        /** dateString: "YYYY-MM-DD" */
        this.date = moment(dateString, 'YYYY-MM-DD').toDate();
      }
    }
  }
</script>

<style scoped>
  .ingredient-title{
    display: block;
    overflow: auto;
    font-weight: bold;
    margin:15px 0 10px 0;
  }
</style>
